<button class="button-green" style="width: 90px;">
    <div>
        <img class="filter-icon" src="assets/filter.svg" />
        Filter
    </div>
</button>
